var _rect, _polyline, _path, _circle, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 44",
    width: 200,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 9,
    fill: "#1e6b2e",
    y: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "7,12 13,30 20,18 27,30 33,12",
    fill: "none",
    stroke: "#f5a623",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,12 A10,10 0 0,1 27,12",
    fill: "none",
    stroke: "#4caf50",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 3.5,
    fill: "#f5a623"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 19,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 16,
    fontWeight: 600,
    fill: "#1e6b2e",
    letterSpacing: -0.3
  }, "Green")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 19,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 16,
    fontWeight: 600,
    fill: "#4caf50",
    letterSpacing: -0.3
  }, "Lens")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 33,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 9,
    fill: "#888",
    letterSpacing: 0.8
  }, "SOLAR INTELLIGENCE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.10066b5266595ba2d68d171003258d45.svg";
export { ForwardRef as ReactComponent };